import {
    FETCH_JET_LAG_TRIPS_FETCHING,
    FETCH_JET_LAG_TRIPS_SUCCESS,
    FETCH_JET_LAG_TRIPS_FAIL,
    DELETE_JET_LAG_TRIP_START,
    DELETE_JET_LAG_TRIP_SUCCESS,
    DELETE_JET_LAG_TRIP_FAIL,
    UPDATE_JET_LAG_TRIP_SUCCESS,
    UPDATE_JET_LAG_TRIP_FAIL
} from 'actions/ActionTypes';

const INITIAL_STATE = {
    trips: [],
    tripsFetching: false,
    tripsSuccess: false,
    tripsFail: false,
    deletingTripsStart: false,
    deletingTripsSuccess: false,
    deletingTripsFails: false,
    updateTripsStart: false,
    updateTripsSucces: false,
    updateTripsFail: false
};

const jetLagTripsFetching = (state) => {
    return {
        ...state,
        tripsFetching: true
    };
};

const fetchJetLagTripsFinished = (isSuccess) => (state, action) => {
    return {
        ...state,
        trips: action.payload,
        tripsFetching: false,
        tripsSuccess: isSuccess,
        tripsFail: !isSuccess
    };
};

const deletingTripsStart = (state) => {
    if (!state.trips) {
        return state;
    }

    return {
        ...state,
        deletingTripsStart: true
    };
};

const deletingTripsFinished = (isSuccess) => (state, action) => {
    if (!state.trips) {
        return state;
    }

    const tripId = action.payload;
    const newTripsList = state.trips.filter((trip) => trip.tripId !== tripId);

    return {
        ...state,
        trips: newTripsList,
        deletingTripsStart: false,
        deletingTripsSuccess: isSuccess,
        deletingTripsFails: !isSuccess
    };
};

const updateTripFinished = (isSuccess) => (state, action) => {
    if (!state.trips) {
        return state;
    }

    const { tripId } = action.payload;
    const updatedTripsList = state.trips.map((trip) => {
        if (trip.tripId === tripId) {
            return { ...action.payload };
        }
        return trip;
    });

    return {
        ...state,
        trips: updatedTripsList,
        updateTripsStart: false,
        updateTripsSucces: isSuccess,
        updateTripsFail: !isSuccess
    };
};

export const getTrips = (state) => state.jetLagTrips.trips;
export const tripsFetching = (state) => state.jetLagTrips.tripsFetching;

const handlers = {
    [FETCH_JET_LAG_TRIPS_FETCHING]: jetLagTripsFetching,
    [FETCH_JET_LAG_TRIPS_SUCCESS]: fetchJetLagTripsFinished(true),
    [FETCH_JET_LAG_TRIPS_FAIL]: fetchJetLagTripsFinished(false),
    [DELETE_JET_LAG_TRIP_START]: deletingTripsStart,
    [DELETE_JET_LAG_TRIP_SUCCESS]: deletingTripsFinished(true),
    [DELETE_JET_LAG_TRIP_FAIL]: deletingTripsFinished(false),
    [UPDATE_JET_LAG_TRIP_SUCCESS]: updateTripFinished(true),
    [UPDATE_JET_LAG_TRIP_FAIL]: updateTripFinished(false)
};

export default function jetLagTrips(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
